import dayjs from 'dayjs'

export default function getMinReturnDate(startDate) {
  return dayjs(startDate, 'DD-MM-YYYY')
    .add(1, 'days')
    .format('DD/MM/YYYY')
}
